export const BLOG_URL = 'https://capawesome.io/blog/';
export const CAL_DEMO_BOOKING_URL =
  'https://cal.com/team/capawesome/cloud-demo';
export const CAL_PARTNERS_BOOKING_URL =
  'https://cal.com/team/capawesome/partners';
export const CAL_IONIC_APPFLOW_MIGRATION_URL =
  'https://cal.com/team/capawesome/ionic-appflow-migration';
export const DISCORD_URL = 'https://discord.gg/VCXxSVjefW';
export const EMAIL_CAREERS = 'careers@capawesome.io';
export const EMAIL_OPENFORGE = 'hello@openforge.io';
export const EMAIL_SALES = 'sales@capawesome.io';
export const EMAIL_SECURITY = 'security@capawesome.io';
export const EMAIL_SUPPORT = 'support@capawesome.io';
export const DOCS_URL = 'https://capawesome.io/cloud/';
export const DOCS_GETTING_STARTED_URL =
  'https://capawesome.io/cloud/live-updates/setup/';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/capawesome';
export const YOUTUBE_URL = 'https://www.youtube.com/@capawesomeio';
export const OPENFORGE_WEBSITE_URL = 'https://openforge.io';
export const TRUST_CENTER_URL = 'https://trust.inc/capawesome-old';
export const X_URL = 'https://x.com/capawesomeio';
